import React from "react";
import { useNavigate, Link } from "react-router-dom";


const HeaderBar = () => (
  <div className="bg-[#333] text-white text-sm py-2 px-4 flex flex-col md:flex-row md:justify-between items-center gap-2 text-center">
    <a href="mailto:admin@kentacademy.co.uk" className="hover:underline">📧 admin@kentacademy.co.uk</a>
    <a
      href="https://www.facebook.com/share/16qS8YJbJc/?mibextid=wwXIfr"
      target="_blank"
      rel="noopener noreferrer"
      className="text-white hover:underline flex items-center gap-1"
    >
      <img src="/assets/facebook-icon.png" alt="Facebook" className="w-5 h-5" />
      facebook.com/KentAcademy
    </a>
  </div>
);

const SiteNav = () => (
  <nav className="bg-white shadow-sm w-full z-50 border-b border-gray-200">
    <div className="max-w-7xl mx-auto px-4 pt-6 pb-4 flex items-center justify-center">
    <Link to="/" className="cursor-pointer">
  <img
    src="/assets/KaLogo.png"
    alt="Kent Academy"
    className="h-40 w-auto object-contain"
  />
</Link>

    </div>
  </nav>
);

export default function Level3Welcome() {
  const navigate = useNavigate();
  return (
    <div className="bg-[#f7f6f3] text-gray-800 min-h-screen">
      <HeaderBar />
      <SiteNav />

      <section className="relative pt-20 pb-10 px-6 w-full">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-light mb-6">
            Level 3 in <span className="font-semibold">Nail Technology</span>
          </h1>
        </div>
      </section>

      <main className="max-w-4xl mx-auto px-6 pb-24">
        {/* Course Structure bilingual */}
        <div className="grid md:grid-cols-2 gap-6 mb-8">
          {/* English */}
          <div className="bg-white rounded-2xl shadow p-6 border border-gray-100">
            <h2 className="text-lg font-semibold mb-2">Course Structure – (EN)</h2>
            <ul className="list-disc pl-5 text-gray-700 space-y-2">
              <li>Manicure</li>
              <li>Pedicure</li>
              <li>Electric Drills</li>
              <li>Acrylic - Clear, Coloured and Pink and White Powder, Embedding glitter in clear acrylic, Ombre</li>
              <li>Nailart to include 3D, marbelling, flowers, glitter and jewel application</li>
              <li>UV gel polish French and Dark</li>
              <li>Be able to show a display of products or promotions</li>
            </ul>
          </div>

          {/* Vietnamese */}
          <div className="bg-white rounded-2xl shadow p-6 border border-gray-100">
            <h2 className="text-lg font-semibold mb-2">Cấu trúc khóa học – (VN)</h2>
            <ul className="list-disc pl-5 text-gray-700 space-y-2">
              <li>Móng</li>
              <li>Chân</li>
              <li>Máy khoan điện</li>
              <li>Acrylic - Bột trong suốt, có màu và hồng và trắng, Nhúng lấp lánh trong acrylic trong suốt, Ombre</li>
              <li>Nailart bao gồm ứng dụng 3D, marbelling, hoa, lấp lánh và đồ trang sức</li>
              <li>Sơn gel UV Pháp và Tối</li>
              <li>Có thể hiển thị màn hình sản phẩm hoặc chương trình khuyến mãi</li>
            </ul>
          </div>
        </div>

        {/* Confirmation and Continue */}
        <div className="bg-white rounded-2xl shadow p-8 border border-gray-100 text-center">
          <h3 className="text-xl font-semibold mb-4">
            Can you do this and want to enrol?<br />
            <span className="text-gray-600">Bạn có muốn đăng ký và làm theo những yêu cầu như này?</span>
          </h3>
          <button
            onClick={() => navigate("/courses/level-3/register")}
            className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-gray-900 text-white hover:opacity-90 transition"
          >
            Continue / Tiếp tục
          </button>
          <p className="mt-4 text-gray-700 text-sm">
            For any queries, please contact us on <strong>+44 7735 906672</strong>
          </p>
        </div>
      </main>

      <footer className="bg-[#333] text-white py-12">
        <div className="max-w-6xl mx-auto px-6 text-center text-xs text-gray-300">
          © {new Date().getFullYear()} Kent Academy. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
